import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from "@mui/material";

import { BiShow } from "react-icons/bi";
import { useGetCarChangeLogsQuery } from "../../../redux/slices/admin/machine/changeLogsSlince.js";
import { useOutletContext } from "react-router-dom";
import { Pagination } from "@mui/material";
import "../../../styles/admin.css/machine-modifications-css/change-logs.css";

export default function ChangeLogs() {
    const { sidebarOpen } = useOutletContext();
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;

    const { data, isLoading: logsLoading } = useGetCarChangeLogsQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });
    const logs = data?.data || [];
    console.log(logs)


    const [openRow, setOpenRow] = useState(null);
    const [selectedPlate, setSelectedPlate] = useState("all");
    const [plateSearch, setPlateSearch] = useState("");

    const normalize = (v) =>
        (v ?? "").toString().replace(/-/g, "").toLowerCase();

    const filteredLogs = logs.filter(emp => {
        const plateMatch =
            selectedPlate === "all" || emp.plateNumber === selectedPlate;

        const searchMatch =
            normalize(emp.plateNumber).includes(normalize(plateSearch));

        return plateMatch && searchMatch;
    });

    // 2. Pagination hesablamaları (Buranı əlavə edin)
    const totalPages = Math.ceil(filteredLogs.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedLogs = filteredLogs.slice(startIndex, startIndex + itemsPerPage);


    const handleShowClick = (emp) => {
        setOpenRow(openRow === emp.id ? null : emp.id);
    };

    useEffect(() => {
        setPage(1);
    }, [plateSearch, selectedPlate]);

    return (
        <Box className={`change-logs-container ${sidebarOpen ? "sidebar-open" : ""}`}>

            <Box className="change-logs-header">
                <Box className="change-logs-title">
                    <Typography style={{ color: "#545A61" }}>Yax dəyişmə tarixçəsi</Typography>
                    <Divider className="change-logs-divider" />
                </Box>

                <Box className="change-logs-filter-row">


                    <TextField
                        size="small"
                        placeholder="Nömrə axtar..."
                        value={plateSearch}
                        className="refund-sale-search"
                        onChange={(e) => setPlateSearch(e.target.value)}
                    />
                </Box>

            </Box>

            <TableContainer component={Paper} className="change-logs-table">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>#No</strong></TableCell>
                            <TableCell><strong>Tam Ad</strong></TableCell>
                            <TableCell><strong>Əlaqə nömrəsi</strong></TableCell>
                            <TableCell><strong>Model</strong></TableCell>
                            <TableCell><strong>Nömrə nişanı</strong></TableCell>
                            <TableCell><strong>Km</strong></TableCell>
                            <TableCell><strong>Edilmə tarixi</strong></TableCell>
                            <TableCell><strong>Seçimlər</strong></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {logsLoading ? (
                            <TableRow>
                                <TableCell colSpan={8} align="center">Yüklənir...</TableCell>
                            </TableRow>
                        ) : paginatedLogs.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={8} align="center">Məlumat tapılmadı</TableCell>
                            </TableRow>
                        ) : (
                            paginatedLogs.map((emp, index) => (
                                <React.Fragment key={emp.id}>
                                    <TableRow>
                                        <TableCell>{"#" + String(emp.serialNo || emp.id).padStart(4, "0")}</TableCell>
                                        <TableCell>{emp.fullname}</TableCell>
                                        <TableCell>+994 {emp.phoneNumber}</TableCell>
                                        <TableCell>{emp.model}</TableCell>
                                        <TableCell>{emp.plateNumber}</TableCell>
                                        <TableCell>{emp.mileageAtSale}</TableCell>

                                        <TableCell>{emp.chagedDate
                                            ? new Date(emp.chagedDate).toLocaleString()
                                            : "-"
                                        }</TableCell>

                                        <TableCell className="manage-wrapper">
                                            <Button size="small" variant="contained" className="change-logs-btn" onClick={() => handleShowClick(emp)} ><BiShow style={{ width: "24px", height: "24px" }} /></Button>
                                        </TableCell>
                                    </TableRow>

                                    {openRow === emp.id && (
                                        <TableRow>
                                            <TableCell colSpan={8} className="change-logs-expanded-cell">
                                                <Box className="change-details-box">
                                                    <TableContainer component={Paper} style={{ boxShadow: "none" }}>
                                                        <Table size="small" className="change-details-table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell><strong>#No</strong></TableCell>
                                                                    <TableCell><strong>Məhsul Adı</strong></TableCell>
                                                                    <TableCell><strong>Kateqoriya</strong></TableCell>
                                                                    <TableCell><strong>Kod</strong></TableCell>
                                                                    <TableCell><strong>Yanacaq Növləri</strong></TableCell>
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                {emp.ıtemShowDtos.map((prod, idx) => (
                                                                    <TableRow key={idx}>
                                                                        <TableCell>{(prod.productId !== null && prod.productId !== undefined)
                                                                            ? "#" + String(prod.productId).padStart(4, "0")
                                                                            : "-"}</TableCell>
                                                                        <TableCell>{Number(prod.serviceFee) === 0 && prod.productName !== null ? prod.productName : prod.serviceName}</TableCell>
                                                                        <TableCell>{Number(prod.serviceFee) === 0 && prod.productName !== null ? prod.subcategoryName : "-"}</TableCell>
                                                                        <TableCell>{prod.code ? prod.code : "-"}</TableCell>
                                                                        <TableCell>{prod.fuelType ? prod.fuelType : "-"}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {filteredLogs.length > itemsPerPage && (
                <Box sx={{ display: 'flex', justifyContent: 'right', p: 3, mt: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => {
                            setPage(value);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                    />
                </Box>
            )}
        </Box>
    );
}
